module.exports = __webpack_public_path__ + "img/ye.be5d2742.svg";